import { render, staticRenderFns } from "./AccountingLayout.vue?vue&type=template&id=c409dfb8"
import script from "./AccountingLayout.vue?vue&type=script&lang=js"
export * from "./AccountingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports